import {
  Dashboard,
} from '@mui/icons-material';
import EmailIcon from '@mui/icons-material/Email';
import HelpIcon from '@mui/icons-material/Help';
import RefreshIcon from '@mui/icons-material/RefreshRounded';
import {
  Box,
  ButtonBase,
  Divider, Link,
} from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import config from '../../../../../config';
import SideMenuHeader from './Components/SideMenuHeader';
import SideMenuLinks from './Components/SideMenuLinks';
import VersionIndicator from './Components/VersionIndicator';
import StyledBox from './styles';

interface SideMenuProps {
  onClose: () => void;
}

export default function SideMenu(props: SideMenuProps) {
  const {
    onClose,
  } = props;
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return (
    <StyledBox role="presentation" sx={{ width: 270 }}>
      <SideMenuHeader onClose={onClose} />
      <Divider />
      <SideMenuLinks onClose={onClose} />
      <div className="grow" />
      <Box className="content">
        <Link href={config.DashboardUrl} target="_blank" underline="hover">
          <Dashboard />
          {t('menu.dashboard')}
        </Link>
        <Link href={t('menu.help.link') as string} target="_blank" underline="hover">
          <HelpIcon />
          {t('menu.help.text')}
        </Link>
        <Link href={`mailto: ${config.SupportMail}`} target="_blank" underline="hover">
          <EmailIcon />
          {t('menu.contactUs')}
        </Link>
        <ButtonBase className="link" onClick={() => { queryClient.invalidateQueries(); }}>
          <RefreshIcon />
          {t('menu.refresh')}
        </ButtonBase>
        <VersionIndicator />
      </Box>
    </StyledBox>
  );
}
